module.exports = __webpack_public_path__ + "media/images/recipes/lendesteak-b851dda834cca53fa5ec750d51295d4a.pdf";